export const I18N_LANGUAGE = "I18N_LANGUAGE";

type I18NAction = typeof I18N_LANGUAGE;

export interface I18NData {
    language: string;
}

export interface I18NPayload {
    type: I18NAction;
    data: any;
}
